module.exports = __webpack_public_path__ + "img/gnu_smart_gallery0.a7df87a4.jpg";